import React, { SyntheticEvent, useCallback } from 'react';
import t from 'modules/i18n/intl';

import { Radio } from '@atlaskit/radio';
import Help from 'components/common/Help';

type TaxIdRadioProps = {
  vatResponsible: boolean | null;
  isTaxIdFieldEmpty: boolean;
  setBillingDetailsForm: (value) => void;
};

const BillingDetailsTaxIdRadio = ({
  vatResponsible,
  isTaxIdFieldEmpty,
  setBillingDetailsForm,
}: TaxIdRadioProps) => {
  const radioChangeHandle = useCallback((e: SyntheticEvent<HTMLInputElement>) => {
    if (e.currentTarget.value === 'required') {
      setBillingDetailsForm((prev) => ({
        ...prev,
        vatResponsible: true,
      }));
    } else if (e.currentTarget.value === 'notRequired') {
      setBillingDetailsForm((prev) => ({
        ...prev,
        vatResponsible: false,
      }));
    }
  }, []);

  if (isTaxIdFieldEmpty) return null;

  return (
    <>
      <Radio
        isChecked={vatResponsible === true}
        name="vatRequired"
        value="required"
        label={
          <>
            {t('checkout.contact.tax-id-vat-required')}
            <Help>{t('checkout.contact.tax-id-vat-required.help')}</Help>
          </>
        }
        onChange={radioChangeHandle}
      />
      <Radio
        isChecked={vatResponsible === false}
        name="vatNotRequired"
        value="notRequired"
        label={t('checkout.contact.tax-id-vat-not-required')}
        onChange={radioChangeHandle}
      />
    </>
  );
};

export default BillingDetailsTaxIdRadio;
